var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"zj-login-page"},[(_vm.THM('login.carousel.visiable', true))?_c('zj-login-carousel'):_vm._e(),_c('div',{staticClass:"zj-login-form-container"},[_c('zj-login-form',{attrs:{"title":_vm.CNF('app.name', '')},on:{"login":_vm.onLogin}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }